import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import { Layout, BodySection } from "../Layout";
import styled, { ThemeContext } from "styled-components";

export const PostShow = ({ event, token }) => {
  const themeContext = useContext(ThemeContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const headerLogo = `${api}/o/${event?.logos?.header?.path}?alt=media`;
  // const footerLogo = `${api}/o/${event?.logos?.footer?.path}?alt=media`;
  const overlayImg = `${api}/o/${event?.postShow?.overlayImage?.path}?alt=media`;

  return (
    <Layout
      // header
      headerShowLogo={false}
      headerLogo={headerLogo}
      headerSecondaryText={event.header}
      // hero
      heroContent={
        <HeroSection>
          <ThankYouHeader>
            {token
              ? event?.postShow?.thankYouHeader
              : "Lo Sentimos, El Show Ya Terminó"}
          </ThankYouHeader>
          <ThankYouBody>
            {token
              ? event?.postShow?.thankYouBody
              : ReactHtmlParser(`
                ¡acompáñanos la próxima vez! Visita <a href="https://www.musicaford.com" target="_blank" rel="noopener noreferrer">www.musicaford.com</a> para más información de los próximos shows
              `)}
          </ThankYouBody>
          {event?.postShow?.overlayImage?.path && (
            <OverlayImage src={overlayImg} />
          )}
        </HeroSection>
      }
      heroPadding={themeContext.postShow?.heroPadding}
      // heading
      heading={event?.postShow?.heading}
      // main
      subHeading={event?.postShow?.subHeading}
      noPadding
      // footer
      footerShowLogo
      footerLogo={headerLogo}
      footerShowText
      footerPrivacyPolicy={event?.footer}
    >
      {event?.postShow?.body ? (
        <BodySection>{ReactHtmlParser(event?.postShow?.body)}</BodySection>
      ) : undefined}
    </Layout>
  );
};

const HeroSection = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.postShow.video.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
  padding: 0 30px;
`;

const ThankYouHeader = styled.h1`
  font-size: 8vw;
  color: white;
  font-family: ${(props) => props.theme.fontStacks.header};
  line-height: 1;
  text-transform: uppercase;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 100px;
  }
`;

const ThankYouBody = styled.h4`
  font-size: 4vw;
  color: #ffffff;
  margin: 0;
  text-transform: uppercase;

  a {
    color: #ffffff;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 40px;
  }
`;

const OverlayImage = styled.img`
  margin-top: ${(props) => props.theme.postShow.overlayImage.marginTop[1]};
  width: ${(props) => props.theme.postShow.overlayImage.width[1]};

  @media only screen and ${(props) => props.theme.maxMedia.small} {
    margin-top: ${(props) => props.theme.postShow.overlayImage.marginTop[0]};
    width: ${(props) => props.theme.postShow.overlayImage.width[0]};
  }
`;
